import React from "react";
import Navbar from "../components/layout/header/Navbar";
import Layout from "../components/layout/Layout";
import PageHeader from "../components/team/PageHeader";
import Footer from "../components/layout/footer/Footer";
import CabeceraBrasil from "../components/destinosSecciones/CabeceraBrasil";
import Transporte from "../components/Transporte/Transporte";
import VideoPromoDestino from "../components/promo/VideoPromoDestino";
import DiversionBrasil from "../components/diversion/DiversionBrasil";
import AsistenciaMedica from "../components/AsistenciaMedica/AsistenciaMedica";
import HoteleriaBrasil from "../components/hoteleria/HoteleriaBrasil";

export default function SecBrasil() {
  return (
    <Layout>
      <Navbar darkBg />
      <PageHeader
        background={"assets/img/brasil/brasil1.jpg"}
        HeaderTitle="Brasil"
        Parent="secundarios"
        PageTitle="Brasil"
      />
      <CabeceraBrasil destino={"Brasil"} />
      <VideoPromoDestino
        background="assets/img/brasil/BannervideoCBU.jpg"
        YoutubeVideoId="bqp4HNXy3rc"
        TextoPromo="Conoce camboriu es una locura"
      />
      <HoteleriaBrasil />
      <DiversionBrasil hasBg={true} />
      <Transporte />
      <AsistenciaMedica bgColor />
      <Footer />
    </Layout>
  );
}
